import { createIcon } from 'native-base';
import React from 'react';
import { Circle } from 'react-native-svg';

export const IconDot = createIcon({
  viewBox: '0 0 24 24',
  path: [<Circle cx="12" cy="12" r="4" fill="currentColor" />],
});
